import { QuestionCreationTaskQuestionCreation } from '@exam-management/question-creation-task-creation';

export default function QuestionCreationCreateSingleQuestionPage() {
  return <QuestionCreationTaskQuestionCreation />;
}
